import sliders from '../sliders/sliders';
import { theme } from '../../constants/defaults';
import cartModalTemplate from '../../templates/cartModalTemplate';
import Cart from './Cart';
import quantitySelect from '../layout/quantitySelect';
import { formatMoney } from '../../utils/product';
import freeShipping from '../free-shipping';

export default class CartModal {
  constructor() {
    if (theme.settings.ajaxCartEnabled) {
      this.cart = Cart.getInstance();
      this.cartContainer = document.getElementById('cart-container');

      const modalNamespace = 'cart-modal';
      this.modal = window.modalManager.idModalMap.get(modalNamespace);

      this.modal.on('before-show', () => {
        this.cartContainer.innerHTML = cartModalTemplate(true);

        this.cart.getState().then(state => {
          this.buildCart(state);
        });
      });

      this.cart.on('updated', (item, state) => {
        console.log(state, 'state');
        this.buildCart(state);
      });
    }
  }

  showPromo(initialState) {
    const totalCartPrice = initialState.total_price;
    const cartItems = initialState.items;
    let cartHasPromo = false;

    const modalNamespace = 'promo-script-modal';
    const modal = window.modalManager.idModalMap.get(modalNamespace);

    cartItems.forEach(cartItem => {
      const { discounts } = cartItem;

      discounts.forEach(discount => {
        if (discount.title === 'Lente-actie') {
          cartHasPromo = true;
        }
      });
    });

    if (totalCartPrice >= 15000 && !cartHasPromo) {
      modal.show();
    }

    if (cartHasPromo) {
      modal.hide();
    }
  }

  buildCart(initialState) {
    this.cartContainer.innerHTML = cartModalTemplate(false, initialState);

    sliders();

    const promoMessage = document.querySelector('.js-cart-promo');
    const totalCartPrice = initialState.total_price / 100.0;

    let promoMessageAmount = document.querySelector('.js-cart-promo span');
    const promoPriceDifference = 7500 - initialState.original_total_price;

    // this.showPromo(initialState);

    const changePromoAmount = () => {
      promoMessageAmount.innerHTML = formatMoney(promoPriceDifference);
    };

    const promoMessageReset = () => {
      promoMessage.innerHTML = theme.strings.cart_promo_pate;
      promoMessageAmount = document.querySelector('.js-cart-promo span');
    };

    const promoMessageComplete = () => {
      promoMessage.innerHTML = theme.strings.cart_promo_complete;
    };

    if (theme.settings.promoMessageEnabled) {
      if (promoPriceDifference <= 0) {
        promoMessageComplete();
      } else {
        promoMessageReset();
        changePromoAmount();
      }
    }

    // Update cart when quantity of item has changed
    const qtySelects = [...this.cartContainer.querySelectorAll('.js-quantity-select')];
    const qtySelectCallback = (input, quantity) => {
      const { key } = input.dataset;
      const itemEl = this.cartContainer.querySelector(`.ajaxcart__product[data-key="${key}"]`);

      if (quantity === 0) {
        // Remove item
        itemEl.classList.add('is-removing');
        this.cart.removeItem(key).then(() => {
          itemEl.remove();
        });
      } else {
        // Update item
        itemEl.classList.add('is-updating');
        this.cart.updateItem(key, { quantity }).then(() => {
          itemEl.classList.remove('is-updating');
        });
      }
    };

    quantitySelect(qtySelects, qtySelectCallback);

    this.cartContainer.querySelectorAll('.js-modal-close').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        this.modal.hide();
      });
    });

    freeShipping(totalCartPrice);
  }
}
